import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const getFormattedDate = (
  date: string,
  formatDate: string = "DD/MM/YYYY"
) => {
  if (!date) {
    return "-";
  }
  const newDate = new Date(date);
  if (!dayjs(newDate).isValid()) {
    return "Invalid Date";
  }
  return `${dayjs.utc(newDate).format(formatDate)}`;
};
